export default "__VITE_ASSET__DlTl2kqY__"